module.exports = __webpack_public_path__ + "img/9791187206866.f6d33b62.jpg";